<!-- <html>
  <head>
    <title>reCAPTCHA demo: Simple page</title>
    <script src='https://www.google.com/recaptcha/api.js?onload=recaptchaOnload&render=explicit' async defer></script>
  </head>

</html> -->
<div class="modal-body">
  <div class="modal-header">
      <h4 class="modal-title ">{{'header.logintab' | translate}}</h4>
      <!-- <i class="fa fa-lock" aria-hidden="true"></i> -->
      <button type="button" (click)="activeModal.dismiss('Cross click')" class="close pointer text-dark"  aria-label="Close">
          <span aria-hidden="true">×</span>
      </button>
  </div>
  <spinner [id]="'loginid'" [show]='activespineer'></spinner>
  <div class="modal-body p-0">
    
    <form class="login-container">
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <label class="">{{'header.userName' | translate}}</label>
            <!-- <input appAlphabetsWithdot [(ngModel)]="UserData['login']" name="User Name" (input)="validateOnchange('login')" type="text" placeholder="{{'header.userName' | translate}}" class="form-control custom-selectbox" autocomplete="off"> -->
            <input id ="username" (keyup)="checkValidation($event)"  [(ngModel)]="UserData['login']" name="User Name"    (input)="validateOnchange('login')" type="text" placeholder="{{'header.userName' | translate}}" class="form-control custom-selectbox" autocomplete="off">
            <p id="warn" style="display:none; color:red">
              Warning: CapsLock is On!
          </p>
            <span style="color:red" [hidden]="validation['login']">Please Enter User Name</span>
          </div>
        </div>
        <div class="col-12">
          <div class="form-group inner-addon right-addon ">
            <label class="">{{'header.password' | translate}}</label>
            <a (click)="showPassword()">
              <i [class]="show_eye ? 'fa fa-eye-slash eye_icon' : 'fa fa-eye eye_icon'"></i>
            </a>
            <input id="password" (keyup)="checkvalidation($event)" appNotAllowSpaces [type]="show_eye ? 'text' : 'password'" [(ngModel)]="UserData['password']"
              name="{{'header.password' | translate}}" (input)="validateOnchange('password')"
              placeholder="{{'header.password' | translate}}" class="form-control custom-selectbox " autocomplete="off">
              <p id="warning" style="display:none; color:red">
                Warning: CapsLock is On!
            </p>
          </div>
        </div>
        <div class="col-12">
          <div class="form-group">
            <label class="">{{'header.captcha' | translate}}</label><br>
              <img  id="capthaId" [(src)]="captchaimage" class="img-fluid" alt="Loading Captha..."/>
              <input  type="text" maxlength=6 id="captcha" name="{{'header.captcha' | translate}}" 
              [(ngModel)]="UserData['captcha']" style="height:40px;width:200px;" class="captcha-input"
               autocomplete="off">&nbsp;
               <button style="font-size: 20px; border-radius: 8px;" (click)="reloadCaptcha()" type="button">⟳</button> <br>
            <span style="color:red" [hidden]="validation['captcha']">Please Verify Captcha</span>
            
           </div>
        </div>
        <div class="col-lg-2 col-md-2"><button type="submit" name="loginbtn"  class="btn btn-primary" (click)="loginClick()">{{'header.datalogin' |translate}}</button></div>
        <div class="col-lg-8"> <button type="submit" name="loginbtn" (click)="openresetpopup()" class="btn btn-link ">{{'header.reset' |translate}}</button></div>

      </div>
    
   
        
       
       
         

        
        
      </form>
      <!-- <div class="row">
        <div class="col-2"></div>
        <div class="col-10">

         
        </div>
      </div> -->
  </div>
</div>